import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { useBatchAddOperations } from 'hooks/batchOperations';
import { useMutation, useQueryClient } from 'react-query';
import {
  ResourceShareAttribute,
  SingleResourceShareResponse,
} from 'types/Share/ResourceShares';
import toastr from 'react-hot-toast';

type mutationVariables = {
  resourceShares: Partial<ResourceShareAttribute>[];
};

export const useBatchAddResourceShare = () => {
  const { mutateAsync: batchAdd } =
    useBatchAddOperations<SingleResourceShareResponse>();
  const queryClient = useQueryClient();

  const addResourceShares = ({ resourceShares }: mutationVariables) => {
    const memoryImageArray = resourceShares.map((share) => ({
      type: SPARK_RESOURCE_TYPES.RESOURCE_SHARES,
      attributes: share,
    }));

    return batchAdd(memoryImageArray);
  };

  return useMutation('addResourceShares', addResourceShares, {
    onSuccess: (results) => {
      const data = results['atomic:results'];
      if (!data.length) {
        return;
      }
      toastr.success('Invite Sent');
      const resourceID = data[0].data.attributes.resourceID;
      const resourceTypeID = data[0].data.attributes.resourceTypeID;
      queryClient.invalidateQueries([
        'resourceShares',
        resourceID,
        resourceTypeID,
      ]);
    },

    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Post resource shares: ${error.message}`);
      }
    },
  });
};
